/* Copyright (c) 2017 Backpack Health LLC */

import React, { FC, useEffect } from 'react';
import { FormattedMessage } from 'react-intl';
import * as _ from 'lodash';
import { connect } from 'react-redux';

import Spacer from '../../../../components/Spacer';
import { Button } from '../../../../components/buttons/Buttons';
import { RelativeDate } from '../../../../localization/LocalizedDate';
import GroupAboutText from '../common/GroupAboutText';
import GroupMetadata from '../../../../../models/GroupMetadata';
import { ViewHeadline } from '../../../../components/Text';
import { Card } from '../../../../../bphComponents/bundle';
import { navigate } from '../../../redux/NavigationActions';
import { selectors as groupSelectors } from '../../../../redux/ducks/group';
import RouteNames from '../../../RouteNames';
import * as selectors from '../../../redux/reduxSelectors';
import { TrackEvent } from '../../../../../utilities/UserMetrics';

interface Props{
  groupMetadata: any;
  membershipData: any;
  onRejoin(): void;
}

function mapStateToProps(state, routerProps) {
  const profileId = selectors.getActiveProfileId(state);
  const groupId = Number(routerProps.match.params.groupId);
  const groupMetadata = groupSelectors.getGroup(state, groupId);
  const membershipData = groupSelectors.getMembership(state, profileId, groupId);

  return {
    groupMetadata,
    membershipData,
    onRejoin: () => {
      navigate(RouteNames.joinGroup(String(groupId), profileId, RouteNames.groupInfo(String(groupId))));
    },
  };
}

const GroupInfoInactive: FC<Props> = (props) => {
  const { membershipData, groupMetadata } = props;
  const { joined_at, left_at } = membershipData;
  const groupId = groupMetadata.id;
  const group = new GroupMetadata(groupMetadata);

  useEffect(() => {
    TrackEvent.groups.groupInfoViewed(group.groupName.getText());
  }, []);

  return (
    <div>
      <Card.CardShape>
        <Card.CardSection hasBottomBorder={groupMetadata.discoverable}>
          <Card.CardContent>
            <ViewHeadline className="theme-group base color">
              <RelativeDate date={joined_at} precision="P1D" dateKind="medium">
                {
                  (date) => (
                    <div className="font-body">
                      <FormattedMessage id="groupInfo.leftGroupDate.field.label" values={{ string1: date }} />
                    </div>
                  )
                }
              </RelativeDate>
              <RelativeDate date={left_at} precision="P1D" dateKind="medium">
                {
                  (date) => (
                    <div className="font-body font-color-gsDarkest" style={{ marginTop: 8 }}>
                      <FormattedMessage id="groupInfo.joinedGroupDate.field.label" values={{ string1: date }} />
                    </div>
                  )
                }
              </RelativeDate>
            </ViewHeadline>
            {
              group.memberCount.enabled.get() && (
                <div className="font-body font-color-gsDarkest" style={{ marginTop: 8 }}>
                  <FormattedMessage id="groupInfo.memberCount.message" values={{ string1: group.memberCount.value.get() }} />
                </div>
              )
            }
          </Card.CardContent>
        </Card.CardSection>

        <Card.CardContent>
          {
            groupMetadata.discoverable &&
            <Button
              style={{
                margin: 0,
                width: '100%',
                padding: '14px 16px',
                borderRadius: '8px',
              }}
              className="theme-group base background font-body"
              onClick={props.onRejoin}
            >
              <FormattedMessage id="groupInfo.rejoinGroup.button.label" />
            </Button>
          }
        </Card.CardContent>
      </Card.CardShape>

      <Card.CardShape>
        <Card.CardContent>
          <GroupAboutText spacerSize="4" groupId={Number(groupId)} />
        </Card.CardContent>
      </Card.CardShape>


    </div>
  );
};

export default connect(mapStateToProps)(GroupInfoInactive);
